import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useComponent, useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'

export const CreateAgreementCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()
  const CreateAgreementForm = useComponent(
    'pages.employerAgreement.sidebar.CreateAgreementForm',
  )
  const tenantId = useHook('routing.tenant.useTenantParam')()
  const { employerAgreementId } = useHook(
    'routing.employer.useEmployerAgreementParams',
  )({ isOptional: true })

  const actions = useHook(
    'mutators.life.useCreateEmployerAgreementCommandActions',
  )({
    tenantId,
    employerAgreementId: employerAgreementId ?? '',
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.CreateAgreementCommandData"
      title={translate('createAgreement.title')}
      commandDataForm={CreateAgreementForm}
      {...props}
      submit={submit}
    />
  )
}
